// extracted by mini-css-extract-plugin
export var active = "_2m-9";
export var backButton = "_2m-8";
export var clone = "_2m-e";
export var collapseBar = "_2m-j";
export var collapseMode = "_2m-l";
export var collapsed = "_2m-n";
export var dragHandle = "_2m-c";
export var dropdownIcon = "_2m-g";
export var expanding = "_2m-m";
export var hidden = "_2m-v";
export var iconContainer = "_2m-p";
export var iconSwapper = "_2m-u";
export var navItem = "_2m-6";
export var navItemIcon = "_2m-f";
export var navProfile = "_2m-7";
export var notificationCountBadge = "_2m-i";
export var notificationDot = "_2m-q";
export var optionsContainer = "_2m-h";
export var primaryNav = "_2m-0";
export var primaryNavDivider = "_2m-t";
export var primaryNavResizeHandle = "_2m-2";
export var primaryNavResizing = "_2m-1";
export var primaryTab = "_2m-o";
export var primaryTabIconBox = "_2m-r";
export var secondaryNav = "_2m-3";
export var selected = "_2m-s";
export var settingsNav = "_2m-4";
export var settingsNavItems = "_2m-5";
export var show = "_2m-d";
export var sideNav = "_2m-k";
export var teamItem = "_2m-a";
export var userProfileItem = "_2m-b";